import React, { useCallback, useEffect, useState } from 'react'
import { Box } from './Styled'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../model/rootReducer'
import { Button, Drawer, Space } from 'antd'
import PathForms from './monitoringForms/PathForms'
import {
  getEventsAction,
  getMonitoringPathAction,
} from '../../../../business/actions/monitoringGraphActions'
import { fillTranscription } from '../../../../business/actions/dialogTranscriptionActions'
import TranscriptionDetails from '../../transcription/transcriptionDetails/TranscriptionDetails'
import { MonitoringPathOptions } from '../../../../model/monitoringGraph/types'

type MonitoringPathProps = {
  exportImage: () => void
}

const MonitoringPathPanel: React.FunctionComponent<MonitoringPathProps> = ({
  exportImage,
}) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState({
    conversationId: '',
    events: '',
    actions: '',
    pathGenerated: false,
    selectedActions: [],
  })
  const [conversationId, setConversationId] = useState('')
  const [visible, setVisible] = useState(false)
  const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot)
  const pathData = useSelector((state: RootState) => state.monitoringGraph.path)
  const transcriptions = useSelector(
    (state: RootState) => state.transcription.transcriptions
  )
  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  var transcription = transcriptions.find(
    (dialog) => dialog.id === conversationId
  )

  useEffect(() => {
    if (pathData.conversationsId[0]) {
      dispatch(fillTranscription(pathData.conversationsId[0]))
      setConversationId(pathData.conversationsId[0])
    }
  }, [pathData.conversationsId])

  useEffect(() => {
    if (selectedBotId) {
      dispatch(getEventsAction.request(null))
    }
  }, [selectedBotId])

  useEffect(() => {
    if (options.pathGenerated) {
      dispatch(
        getMonitoringPathAction.request(
          new MonitoringPathOptions(
            options.conversationId,
            options.events,
            options.actions
          )
        )
      )
    }
  }, [options])

  const generatePath = useCallback(
    (selectedFilters) => {
      var events = ''
      selectedFilters.events.forEach((element: any) => {
        events = events + ';' + element
      })
      setOptions({
        conversationId: selectedFilters.conversationId,
        events,
        actions: '',
        pathGenerated: true,
        selectedActions: [],
      })
    },
    [options]
  )

  const updatePath = useCallback(() => {
    var actions = ''
    options.selectedActions.forEach((element: any) => {
      actions = actions + ';' + element
    })
    setOptions({ ...options, conversationId, actions, pathGenerated: true })
  }, [options])

  const ExportGraph = () => {
    return (
      <Button type="primary" onClick={exportImage}>
        Exporter une image
      </Button>
    )
  }
  return (
    <div>
      <PathForms
        generatePath={generatePath}
        updatePath={updatePath}
        setConversationId={(conversationId: string) =>
          setConversationId(conversationId)
        }
        selectedActions={options.selectedActions}
      />
      {pathData.availableActions.length > 0 && (
        <div>
          <Box>
            <Space>
              <ExportGraph />
              <Button type="primary" onClick={showDrawer}>
                Ouvrir la transcription
              </Button>
            </Space>
          </Box>
          <Drawer
            width={700}
            title="Transcription"
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
          >
            {transcription && (
              <TranscriptionDetails transcription={transcription} />
            )}
          </Drawer>
        </div>
      )}
    </div>
  )
}
export default MonitoringPathPanel
